import { render, staticRenderFns } from "./AccessorialsByType.vue?vue&type=template&id=82fa6998&scoped=true"
import script from "./AccessorialsByType.vue?vue&type=script&lang=js"
export * from "./AccessorialsByType.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsByType.vue?vue&type=style&index=0&id=82fa6998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa6998",
  null
  
)

export default component.exports